import { UntypedFormBuilder, Validators } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { ProvisionCalculationType } from "./ProvisionCalculationType";

export interface PeriodicalValue {
    id: number;
    identifier: string;
    fromDate?: Date;
    toDate?: Date;
    value: number;
    calculationTypeId: number;
    createdBy?: string;
    timestamp?: string;
}


export class PeriodicalValueFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, data: PeriodicalValue)  {
  
      return fb.group(
        {
            id:[data.id],
            identifier: [data.identifier],
            fromDate: [this.dateValue(data.fromDate), [Validators.required]],
            toDate: [this.dateValue(data.toDate)],
            value: [data.value, [Validators.required, Validators.min(0)]],
            calculationTypeId : [data.calculationTypeId],
        }
      );
    }

    static initPeriodicalValue(identifier:string): PeriodicalValue {
      return {
        id:0,
        identifier:identifier,
        fromDate: new Date(),
        value: 0.00,
        calculationTypeId : ProvisionCalculationType.Percent
      };
  
    }

  }
